const PREFIX = 'LOBBY_ALERTS';

export const API_URL = '/api_web/portal/lobby_alerts';

export const SUBMIT_LOBBY_ALERTS = `${PREFIX}/SUBMIT_LOBBY_ALERTS`;
export const SUBMIT_LOBBY_ALERTS_DONE = `${PREFIX}/SUBMIT_LOBBY_ALERTS_DONE`;
export const SUBMIT_LOBBY_ALERTS_ERROR = `${PREFIX}/SUBMIT_LOBBY_ALERTS_ERROR`;
